export const headCopy = {
  head_playground_title:
    "プレイグラウンド - TypeScriptとJavascriptを探求するためのオンラインエディタ",
  head_playground_description:
    "プレイグラウンドで、TypeScriptとJavascriptのコードをオンラインで安全に共有できる形で書くことができます",
  tsconfig_title:
    "TSConfig リファレンス - すべてのTSConfigのオプションのドキュメント",
  tsconfig_description:
    "allowJs から useDefineForClassFields まで、TSConfigのドキュメントは、TypeScriptプロジェクトで設定可能なコンパイラオプションのすべてを含んでいます",
  playground_example_prefix: "プレイグラウンド 例 - ",

  head_index_title: "どんな規模でも型付けされたJavaScriptを",
  head_index_description: "どんな規模でも型付けされたJavaScriptを",
}
